<template>
  <load-form-handler
    :promise="getTabPromise"
    v-model="resource"
    placeholder
    @load-end="onLoadEnd"
    @error="onRequestError">

    <h1 class="text-center">Nosso questionário é rápido e muito importante para nós. Vamos começar?</h1>
    <v-divider class="divider-accent my-4"/>

    <v-form @submit.prevent="updateTab" id="tab-form" ref="form">

      <v-card>
        <v-flex pa-4>
          <v-layout align-center justify-center column mb-4>
            <h2 class="text-center">Formulários com os dados cadastrais do aluno.</h2>
            <h3 class="text-center text-secondary">Forms with the student's cadastral data.</h3>
          </v-layout>
          <form-student ref="form_student" class="mb-4"/>

          <h2>Histórico escolar</h2>
          <h3 class="text-secondary mb-2">School history</h3>
          <form-school-history ref="form_school_history"/>
        </v-flex>
      </v-card>

    </v-form>

    <alert-modal
      :visibility="declarationModalVisibility"
      title="Confirmação de dados"
      :message="declarationMessage"
      confirmAction="OK"
      cancelAction="CANCELAR"
      @confirm="onDeclarationModal"
      @cancel="closeDeclarationModal" />

  </load-form-handler>
</template>

<script>
import FormStudent from './FormStudent'
import FormSchoolHistory from './FormSchoolHistory'
import * as api from '@/api'
import LoadFormHandler from '@/components/LoadFormHandler'
import { mapActions } from 'vuex'
import { formTabs, message, declaration, tab } from '@/mixins'
import AlertModal from '@/components/AlertModal'

/**
 * @group Form
 * Componete responsável pelo cadastro de dados de aluno e responsável
 */
export default {
  name: 'FormStudentIdentification',

  data: () => ({
    resource: {}
  }),

  mixins: [formTabs, message, declaration, tab],

  provide () {
    const resource = {}
    Object.defineProperty(resource, 'form', {
      enumerable: true,
      get: () => this.resource
    })
    return { resource }
  },

  components: {
    FormStudent,
    FormSchoolHistory,
    AlertModal,
    LoadFormHandler
  },

  methods: {
    ...mapActions({
      showSnack: 'snackbar/showSnack'
    }),

    getTabPromise () {
      return api.forms.studentIdentification.get(this.currentStudentId)
    },

    /**
     * @vuese
     * Método para atualização da aba
     */
    updateTab () {
      if (this.$refs.form.validate()) {
        this.openDeclarationModal()
      } else {
        this.showMessageByType(this.messageTypes.VALIDATION_ERROR)
      }
    },

    /**
     * @vuese
     * Método para atualização de dados da form
     */
    sendUpdateRequest (resource) {
      api.forms.studentIdentification.update(this.resource.id, resource)
        .then(({ data }) => {
          this.resource = data
          this.$forceUpdate()
          this.showMessageByType(this.messageTypes.MODIFIED)
        }).catch(this.handleErrorMessage)
        .finally(this.closeDeclarationModal)
    },

    // @vuese Método de evento da modal
    onDeclarationModal () {
      this.sendUpdateRequest(this.resource)
    }
  }
}
</script>
